<template>
    <el-popover placement="bottom" width="160" v-model="showMarginType">
        <div style="margin-bottom:5px">
            <el-button @click="change('CROSSED')" style="width:100%">全仓</el-button>
        </div>
        <div>
            <el-button @click="change('ISOLATED')" style="width:100%">逐仓</el-button>
        </div>
        <template #reference>
            <el-button icon="ArrowDownBold" style="width:120px" :loading="submitMarginTypeLoding">
                <span>{{ current.binanceConfig.marginType === constants.CROSS ? '全仓' : '逐仓' }}</span>
            </el-button>
        </template>
    </el-popover>
</template>

<script setup>
import { ref, toRaw } from 'vue'
import { ElMessage } from 'element-plus'
import * as constants from '@/utils/binanceConstants'
import { useSystemStore } from '@/stores/system'
import { useLogStore } from '@/stores/log'

const systemStore = useSystemStore()
const logStore = useLogStore()
const showMarginType = ref(false)
const submitMarginTypeLoding = ref(false)
const current = ref(systemStore.currentusymbol)

const change = (type) => {
    if (current.value.binanceConfig.marginType === type) return
    save(type)
}

const save = async (type) => {
    // 保存原来的值，用于回滚
    const originalMarginType = current.value.binanceConfig.marginType

    try {
        submitMarginTypeLoding.value = true

        // 乐观更新：立即更新UI
        let _obj = {
            name: current.value.name,
            config: {
                marginType: type,
                leverage: current.value.binanceConfig.leverage,
            }
        }
        systemStore.updateBinanceConfig(_obj)
        current.value = systemStore.currentusymbol

        // 调用API
        await systemStore.privateClient.setMarginType(current.value.symbol, type)

        ElMessage.success('保存成功')
        showMarginType.value = false

    } catch (error) {
        // ❌ 失败时回滚到原来的值
        let rollbackObj = {
            name: current.value.name,
            config: {
                marginType: originalMarginType,
                leverage: current.value.binanceConfig.leverage,
            }
        }
        systemStore.updateBinanceConfig(rollbackObj)
        current.value = systemStore.currentusymbol

        ElMessage.error('保存失败：' + (error.message || error))
        logStore.addLog({
            title: '保存持仓模式失败',
            level: 'error',
            message: error
        })
    } finally {
        submitMarginTypeLoding.value = false
    }
}

</script>